import apiService from '@/services/apiService';

const actions = {
  getCaptchas({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('image-captcha/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCaptcha({ commit }, payload) {
    apiService.get(`image-captcha/${payload}`)
      .then((response) => {
        commit('getCaptcha', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postCaptcha({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('image-captcha', payload)
        .then((response) => {
          commit('postCaptcha', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCaptcha({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`image-captcha/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putCaptcha', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delCaptcha({ commit }, payload) {
    apiService.delete(`image-captcha/${payload}`)
      .then((response) => {
        commit('delCaptcha', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
